import { Container } from "@/components/atoms";
import { TestimonialCard } from "@/components/molecules";
import { useTestimonials } from "@/hooks/use-testimonials";

// Testimonials (frame 24:2).
//
// DRB-64: this used to render a hardcoded array while the admin managed a Firestore collection
// that nothing read. Now it renders what she actually controls, so editing a quote in the admin
// changes the site. An empty collection renders nothing rather than falling back — if she removes
// every testimonial that is a decision, not a failure — but a genuine READ FAILURE still shows the
// shipped copy so this section can never collapse on a transient error.
export function Testimonials() {
  const { testimonials, loading } = useTestimonials();
  if (loading || testimonials.length === 0) return null;
  return (
    <section className="py-14">
      <Container>
        <div className="mb-8 text-center">
          <h2 className="font-condensed text-3xl font-bold text-night-blue">
            What patients are saying
          </h2>
          <p className="mt-2 text-night-blue/70">
            Reliable. Trustworthy. Professional.
          </p>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {[...testimonials]
            .sort((a, b) => a.order - b.order)
            .map((t) => (
              <TestimonialCard key={t.id} testimonial={t} />
            ))}
        </div>
      </Container>
    </section>
  );
}
